module.exports = __webpack_public_path__ + "img/delete_icon.06f569d4.svg";